
(() => {
  const custom_css = `
    /* prevent scrolling the body when modal is open */
    body:has(.px-modal) {
        overflow: hidden;
    }
    
    .px-modal {
        --close-button-width: 30px;
        --close-button-height: 30px;
        --modal-width: min(90%, 100% - calc(2 * var(--close-button-width)));
        --modal-height: min(90%, 100% - calc(2 * var(--close-button-height)));
        background: #fff8;
        display: flex;
        align-items: center;
        justify-content: center;
        position: fixed;
        width: 100vw;  width:100dvw;
        height: 100vh; height: 100dvh;
        left: 0;
        top: 0;
        z-index: 999999;
    }
    
    .px-modal.px-integration-type-editor,
    .px-modal.px-integration-photo-prints {
        --modal-width: min(150px, 80%);
        --modal-height: min(150px, 80%);
    }
    .px-modal.px-integration-type-options-to-editor {
        --modal-width: min(600px, 80%, 100% - calc(2 * var(--close-button-width)));
    }    
    .px-modal > iframe {
        background: #fff;
        border: none;
        border-radius: 8px;
        width: var(--modal-width);
        height: var(--modal-height);
        box-shadow: 0 0 60px 0 #888;
        transition: width 0.1s, height 0.1s;
    }
    
    .px-modal.px-fullscreen > iframe {
        --modal-width: 100%;
        --modal-height: 100%;
        border-radius: 0;
    }
    
    .px-modal .px-close {
        background: #fff;
        box-shadow: 0 0 60px 0 #888;
        border-radius: max(var(--close-button-width), var(--close-button-height));
        cursor: pointer;
        display: block;
        font-size: 0;
        width: var(--close-button-width);
        height: var(--close-button-height);
        position: absolute;
        left: calc(((100% - var(--modal-width)) / 2) + var(--modal-width));
        bottom: calc(((100% - var(--modal-height)) / 2) + var(--modal-height));
    }
    
    .px-modal .px-close::before {
        content: url('data:image/svg+xml,<svg width="30" height="30" viewBox="0 0 30 30" fill="none" stroke="currentColor" stroke-width="2.5" stroke-opacity="0.5" xmlns="http://www.w3.org/2000/svg"><line x1="9" y1="9" x2="21" y2="21" /><line x1="21" y1="9" x2="9" y2="21" /></svg>');
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 2em;
        width: 100%;
        height: 100%;
    }
    
    .px-modal.px-fullscreen .px-close,
    .px-modal.px-integration-type-editor .px-close,
    .px-modal.px-integration-type-photo-prints .px-close {
        display: none;
    }
  `;
  
  class ProductDataLoader {
    constructor() {
      this.loading = false;
      this.loaded = false;
      this.products = {};
      this.productPromiseResolvers = {};
    }
    
    load() {
      if (this.loading || this.loaded) {
        return;
      }
      this._loadPage(1);
    }

    get(product_id) {
      this.load();
      if (this.products[product_id]) {
        return Promise.resolve(this.products[product_id]);
      } else if (this.loaded) {
        return Promise.resolve(null);
      } else {
        if (!this.productPromiseResolvers[product_id]) {
          this.productPromiseResolvers[product_id] = [];
        }
        // Nit: Use Promise.withResolvers() when it's better supported.
        let resolve;
        const promise = new Promise((res, rej) => {
          resolve = res;
        });
        this.productPromiseResolvers[product_id].push(resolve);
        return promise;
      }
    }
    
    _loadPage(page) {
      this.loading = true;
      
      fetch(`/pages/pixfizz-product-api?page=${page}`).then(r => r.json()).then(json => {
        Object.keys(json).forEach(product_id => {
          this.products[product_id] = json[product_id];
          if (this.productPromiseResolvers[product_id]) {
            this.productPromiseResolvers[product_id].forEach(resolver => resolver(this.products[product_id]));
            this.productPromiseResolvers[product_id] = [];
          }
        });
        if (Object.keys(json).length > 0) {
          this._loadPage(page + 1);
        } else {
          this.loaded = true;
          this.loading = false;
          Object.keys(this.productPromiseResolvers).forEach(product_id => {
            this.productPromiseResolvers[product_id].forEach(resolver => resolver(null));
            this.productPromiseResolvers[product_id] = [];
          });
        }
      });      
    }
  }
  
  window.Pixfizz = {};
  Pixfizz.Shopify = {};
  Pixfizz.Shopify.pixfizz_origin = null;
  Pixfizz.Shopify.locale = null;
  Pixfizz.Shopify.cart_target = null;
  Pixfizz.Shopify.skip_draft_redirect = false;
  Pixfizz.Shopify.draft_toast_message = null;
  Pixfizz.Shopify.product_data_loader = new ProductDataLoader();
  Pixfizz.Shopify._user = null;
  Pixfizz.Shopify._hash = null;
  Pixfizz.Shopify._modal = null;
  Pixfizz.Shopify._session_established = false;

  Pixfizz.Shopify.setup = function(hostname, user, hash, options) {
    options = options || {};
    
    Pixfizz.Shopify.pixfizz_origin = hostname ? `https://${hostname}` : null;
    Pixfizz.Shopify._user = user || null;
    Pixfizz.Shopify._hash = hash || null;
    if (options.locale) {
        Pixfizz.Shopify.locale = options.locale;
    }
    if (options.cart_target) {
        Pixfizz.Shopify.cart_target = options.cart_target;
    }
    if (options.skip_draft_redirect) {
        Pixfizz.Shopify.skip_draft_redirect = true;
    }
    if (options.draft_toast_message) {
        Pixfizz.Shopify.draft_toast_message = options.draft_toast_message;
    }

    const init = () => {
      // Inject custom styles into the head.
      const style = document.createElement('style');
      style.textContent = custom_css;
      document.head.appendChild(style); 
      // Log user into Pixfizz.
      Pixfizz.Shopify.establishSession();
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  };

  let active_request = null;

  Pixfizz.Shopify.establishSession = function(callback) {
    callback = callback || function() {};
    
    if (Pixfizz.Shopify._session_established) {
      callback();
      return;
    }

    const iframe_params = {};
    
    if (Pixfizz.Shopify.locale) {
      iframe_params.locale = Pixfizz.Shopify.locale;
    }

    if (Pixfizz.Shopify._user) {
      iframe_params['user[uid]'] = Pixfizz.Shopify._user.uid;
      iframe_params['user[email]'] = Pixfizz.Shopify._user.email;
      iframe_params['hash'] = Pixfizz.Shopify._hash;
    }

    if (active_request) {
      active_request.pending_callbacks.push(callback);
    } else {
      active_request = {pending_callbacks: [callback]};
    }

    const iframe = document.createElement('iframe');
    iframe.hidden = true;

    const tokenMessageListener = (evt) => {
      if (evt.source !== iframe.contentWindow) {
        return;
      }
      if (evt.data.type === 'token') {
        const token = evt.data.data.token;
        if (token) {
          Pixfizz.Shopify._session_established = true;
          if (active_request) {
            active_request.pending_callbacks.forEach(cb => cb());
          }
        }
        active_request = null;
        iframe.remove();
        window.removeEventListener('message', tokenMessageListener);
      }
    };
    window.addEventListener('message', tokenMessageListener);

    iframe.src = `${Pixfizz.Shopify.pixfizz_origin}/site/shopify/token?${new URLSearchParams(iframe_params)}`;
    document.body.appendChild(iframe);
  };

  Pixfizz.Shopify.openModal = function(url, options) {
    options = options || {};
    const modal = document.createElement('div');
    modal.classList.add('px-modal');
    if (options.fullscreen) {
      modal.classList.add('px-fullscreen');
    }
    if (options.className) {
      modal.classList.add(options.className);
    }
    if (!options.fullscreen) {
      const btn = document.createElement('div');
      btn.className = 'px-close';
      btn.onclick = () => Pixfizz.Shopify.closeModal();
      modal.appendChild(btn);
    }
    const iframe = document.createElement('iframe');
    Pixfizz.Shopify.establishSession(() => {
      const src = new URL(url);
      iframe.src = src.toString();
      modal.appendChild(iframe);
      document.body.appendChild(modal);
    });
    Pixfizz.Shopify._modal = modal;
    return modal;
  };

  Pixfizz.Shopify.closeModal = function() {
    if (Pixfizz.Shopify._modal) {
      Pixfizz.Shopify._modal.remove();
      Pixfizz.Shopify._modal = null;
    }
  };

  Pixfizz.Shopify._showDraftToast = function() {
    const message = Pixfizz.Shopify.draft_toast_message || 'Added to cart';
    const toast = document.createElement('div');
    toast.setAttribute('role', 'status');

    const cartIcon = document.getElementById('cart-icon-bubble');
    const isDesktop = window.innerWidth >= 768;

    const baseStyles = [
      'position:fixed',
      'background:#333',
      'color:#fff',
      'padding:14px 20px',
      'border-radius:6px',
      'z-index:9999999',
      'font-size:14px',
      'line-height:1.4',
      'max-width:320px',
      'box-shadow:0 4px 16px rgba(0,0,0,0.25)',
      'opacity:0',
      'transition:opacity 0.3s ease'
    ];

    if (isDesktop && cartIcon) {
      const rect = cartIcon.getBoundingClientRect();
      baseStyles.push(`top:${Math.round(rect.bottom + 12)}px`);
      baseStyles.push(`right:${Math.round(window.innerWidth - rect.right)}px`);
    } else {
      baseStyles.push('bottom:24px');
      baseStyles.push('left:50%');
      baseStyles.push('transform:translateX(-50%)');
      baseStyles.push('text-align:center');
    }

    toast.style.cssText = baseStyles.join(';');
    toast.textContent = message;
    document.body.appendChild(toast);
    requestAnimationFrame(() => { toast.style.opacity = '1'; });
    setTimeout(() => {
      toast.style.opacity = '0';
      setTimeout(() => toast.remove(), 300);
    }, 5000);
  };

  Pixfizz.Shopify.launchProduct = function(sku, integration_type, product_id, variant_id, parameters, options) {
    parameters = parameters || {};
    options = Object.assign({page: '/site/shopify/product'}, options || {});
    const query = new URLSearchParams({
      sku: sku,
      integration: integration_type,
      shopify_product_id: product_id,
      shopify_variant_id: variant_id,
    });
    // Backwards compatibility -- this should be handled in the shopify pixfizz-launch-product-handler.liquid by
    // recent integrations, but older integrations may still depend on this function to set the quantity.
    if (!parameters.hasOwnProperty('quantity')) {
      const quantity_input = document.querySelector('input[name="quantity"]');
      if (quantity_input) {
        parameters.quantity = quantity_input.value;
      }
    }
    Object.keys(parameters).forEach(key => {
      query.set(key, parameters[key]);
    });
    const url = `${Pixfizz.Shopify.pixfizz_origin}${options.page}?${query}`;
    Pixfizz.Shopify.openModal(url, {className: `px-integration-type-${integration_type}`});
  };
  
  Pixfizz.Shopify.launchPhotoPrints = function(parameters, options) {
    if (!parameters.collection_path && !parameters.project_id) {
      throw new Error('At least one of `collection_path`, `project_id` needs to be given.');
    }
    options = Object.assign({page: '/site/shopify/photo-prints'}, options || {});
    const query = new URLSearchParams();
    if (parameters.collection_path) {
      query.set('collection_path', parameters.collection_path);
    }
    if (parameters.project_id) {
      query.set('project_id', parameters.project_id);
    }
    Object.keys(parameters).forEach(key => {
        query.set(key, parameters[key]);
    });
    const url = `${Pixfizz.Shopify.pixfizz_origin}${options.page}?${query}`;
    Pixfizz.Shopify.openModal(url, {className: 'px-integration-type-photo-prints', fullscreen: true});
  };

  Pixfizz.Shopify.launchProject = function(project_id, parameters, options) {
    parameters = parameters || {};
    parameters.quantity = parameters.quantity || 1;
    options = options || {};
    if (options.push_state !== false) {
      const url = new URL(window.location);
      const project_data = {
        project_id: project_id,
        parameters: parameters,
        options: options
      };
      url.searchParams.set('project-designer', btoa(JSON.stringify(project_data)));
      history.pushState({
        pixfizz: true,
        type: 'launch_project',
        data: project_data
      }, '', url.toString());
    }
    if (options.design_tool) {
      let edit_url = new URL(`${Pixfizz.Shopify.pixfizz_origin}/v1/editor`);
      edit_url.searchParams.set('book', project_id);
      edit_url.searchParams.set('homepage_target', window.location.origin);
      edit_url.searchParams.set('integration', 'Shopify');
      Object.keys(parameters).forEach(key => {
        edit_url.searchParams.set(key, parameters[key]);
      });
      Pixfizz.Shopify.openModal(edit_url, {fullscreen: true});
    } else if (options.photo_prints_tool) {
      parameters.project_id = project_id;
      Pixfizz.Shopify.launchPhotoPrints(parameters, {fullscreen: true});
    } else {
      let edit_url = new URL(`${Pixfizz.Shopify.pixfizz_origin}/site/shopify/project-edit`);
      edit_url.searchParams.set('project_id', project_id);
      Object.keys(parameters).forEach(key => {
        edit_url.searchParams.set(key, parameters[key]);
      });
      Pixfizz.Shopify.openModal(edit_url, {fullscreen: false});
    }
  };
  
  Pixfizz.Shopify.launchSavedProject = function (project_id, product_id, variant_id) {
    const product_data = Pixfizz.Shopify.product_data_loader.get(product_id).then(product_data => {
      if (product_data && product_data.pixfizz_sku_map[variant_id]) {
        const addons_map = product_data.pixfizz_addons_map[variant_id];
        const parameters = {
          shopify_variant_id: variant_id,
          page_addon: addons_map.page_addon || '',
          option_addons: JSON.stringify(addons_map.option_addons || {})
        };
        let options;
        if (product_data.integration_type === 'options-to-cart') {
          options = {
            push_state: false
          };
        } else if (product_data.integration_type === 'photo-prints') {
          options = {
            photo_prints_tool: true,
            push_state: true
          };
        } else {
          options = {
            design_tool: true,
            push_state: true
          };
        }
        Pixfizz.Shopify.launchProject(
          project_id,
          parameters,
          options
        ); 
      }
    });
  };

  Pixfizz.Shopify.loadProjectPreview = function(project_id, options, callback) {
    options = Object.assign({page: '/site/shopify/preview'}, options || {});

    const iframe = document.createElement('iframe');
    iframe.hidden = true;

    const previewMessageListener = (evt) => {
      if (evt.source !== iframe.contentWindow) {
        return;
      }
      const src = evt.data.data.src || URL.createObjectURL(new Blob([evt.data.data.buffer], {type: evt.data.data.type}));
      if (evt.data.type === 'project-preview-update') {
        callback(src);
      } else if (evt.data.type === 'project-preview-complete') {
        callback(src, true);
        iframe.remove();
        window.removeEventListener('message', previewMessageListener);
      }
    };
    window.addEventListener('message', previewMessageListener);

    Pixfizz.Shopify.establishSession(() => {
        const iframe_params = {
            project_id: project_id
        };
        if (options.width) {
          iframe_params.width = options.width;
        }
        if (options.height) {
          iframe_params.height = options.height;
        }
        iframe.src = `${Pixfizz.Shopify.pixfizz_origin}${options.page}?${new URLSearchParams(iframe_params)}`;
        document.body.appendChild(iframe);
    });
  };

  Pixfizz.Shopify.replaceImageWithProjectPreview = function(img, project_id, options) {
    img.style.opacity = 0;
    Pixfizz.Shopify.loadProjectPreview(project_id, options, (src, complete) => {
      img.src = src;
      img.srcset = src;
      img.style.opacity = complete ? 1 : 0.5;
    });
  };
  
  Pixfizz.Shopify.getSavedProjects = function(callback, options) {
    options = options || {};

    Pixfizz.Shopify.establishSession(() => {
      const cors_opts = {
        mode: 'cors',
        credentials: 'include'
      };
      
      const user_url = `${Pixfizz.Shopify.pixfizz_origin}/v1/users/me.json`;
      fetch(user_url, cors_opts).then(r => r.json()).then(user => {
        const books_url = `${Pixfizz.Shopify.pixfizz_origin}/v1/users/${user.id}/books.json?page=${options.page || 1}`;
        fetch(books_url, cors_opts).then(r => r.json()).then(books => callback(books));
      });
    });
  }
  
  const addProjectToCart = async (variant_id, quantity, properties, addons) => {
    localStorage.setItem('selectedProduct', 0);
    localStorage.setItem('selectedProductVariant', variant_id);
    const items = [{
      id: variant_id,
      quantity: quantity,
      properties: properties
    }];
    
    if (addons) {
      addons.forEach(addon => {
        items.push({
          id: addon.variant_id,
          quantity: addon.quantity * quantity,
          properties: {
            _pixfizz_addon: properties._pixfizz_project_id,
            _pixfizz_unit_quantity: addon.quantity
          }
        });
      });
    }

    try {
        const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
            method: 'POST',
            body: JSON.stringify({ items: items }),
            headers: {
                'Content-Type': 'application/json'
            }
        });

        if (!response.ok) {
            console.error("Add to cart failed:", response.statusText);
            alert("Failed to add PER product to cart.");
            return;
        }

       
        // Redirect after a tiny delay (50–200ms)
        setTimeout(() => {
            window.location.href = "/pages/delivery-details";
        }, 100);

    } catch (err) {
        console.error("Error adding to cart:", err);
        alert("Error adding PER product to cart.");
    }
};

  
  const updateProjectInCart = async (line_item_key, quantity, properties, addons, pixfizz_prop_names) => {
    const cart = await fetch(`${Shopify.routes.root}cart.js`).then(r => r.json());
    const project_line = cart.items.find(item => item.key === line_item_key);
    // Make sure to retain any existing (non-pixfizz) properties.
    const combined_properties = Object.assign({}, project_line.properties);

    // We check whether `pixfizz_prop_keys` is defined for backwards compatibility reasons
    // during the deployment rollout. We can remove this check after a few days, since `pixfizz_prop_keys`
    // should always be present after the updates are live and everyone has reloaded their browser.
    if (pixfizz_prop_names) {
      pixfizz_prop_names.forEach(key => {
        delete combined_properties[key];
      });
    }
    
    Object.keys(properties).forEach(key => {
      combined_properties[key] = properties[key];
    });
    
    if (addons && addons.length) {
      // When project may contain addons, we always remove both the project and any existing addons from the cart first,
      // and then add them back in to ensure that they are always grouped together in the cart.
      const pixfizz_project_id = project_line.properties._pixfizz_project_id;
      
      const item_keys_to_delete = [line_item_key];
      const items_to_create = [{
        id: project_line.variant_id,
        quantity: quantity,
        properties: combined_properties
      }];
      
      addons.forEach(addon => {
        const existing_addon_item = cart.items.find(item => {
          return item.variant_id.toString() === addon.variant_id.toString() && item.properties._pixfizz_addon === pixfizz_project_id;
        });
        if (existing_addon_item) {
          item_keys_to_delete.push(existing_addon_item.key);
        }
        const total_quantity = addon.quantity * quantity;
        if (total_quantity > 0) {
          items_to_create.push({
            id: addon.variant_id,
            quantity: total_quantity,
            properties: {
              _pixfizz_addon: pixfizz_project_id,
              _pixfizz_unit_quantity: addon.quantity
            }
          });
        }
      });
      const cart_updates = {};
      item_keys_to_delete.forEach(key => cart_updates[key] = 0);

      await fetch(`${Shopify.routes.root}cart/update.js`, {
        method: 'POST',
        body: JSON.stringify({updates: cart_updates}),
        headers: {
          'Content-Type': 'application/json'
        }
      });
      
      return await fetch(`${Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        body: JSON.stringify({items: items_to_create}),
        headers: {
          'Content-Type': 'application/json'
        }
      });
    } else {
      // When not using addons, we can use the /change.js endpoint to just update the existing orderline in-place.
      const project_updates = {
        id: line_item_key,
        quantity: quantity,
        properties: combined_properties
      };
      return await fetch(`${Shopify.routes.root}cart/change.js`, {
        method: 'POST',
        body: JSON.stringify(project_updates),
        headers: {
          'Content-Type': 'application/json'
        }
      });
    }
  };

  window.addEventListener('message', (evt) => {
    if (evt.origin !== Pixfizz.Shopify.pixfizz_origin || !evt.data.pixfizz) {
      return;
    }
    const modal = Pixfizz.Shopify._modal;
    if (!modal || modal.querySelector('iframe').contentWindow !== evt.source) {
      return;
    }

    switch (evt.data.type) {
      case 'close': {
        Pixfizz.Shopify.closeModal();
        break;
      }
      case 'goto': {
        window.location = evt.data.data.url;
        break;
      }
      case 'goto_cart': {
        window.location = `${Shopify.routes.root}cart`;
        break;
      }
      case 'launch_project': {
        Pixfizz.Shopify.closeModal();
        Pixfizz.Shopify.launchProject(evt.data.data.project_id, evt.data.data.parameters, evt.data.data.options);
        break;
      }
      case 'close_project': {
        const url = new URL(window.location);
        url.searchParams.delete('project-designer');
        window.location = url.toString();
        break;
      }
      case 'add_to_cart': {
        addProjectToCart(
          evt.data.data.shopify_variant_id,
          evt.data.data.quantity,
          evt.data.data.properties,
          evt.data.data.addons
         ).then(() => {
          if (evt.ports[0]) {
            evt.ports[0].postMessage({type: 'done'});
          }
          const is_draft_add = evt.data.data.properties && evt.data.data.properties._pixfizz_draft === true; // CHANGE 3
          if (evt.data.data.redirect !== false && !(is_draft_add && Pixfizz.Shopify.skip_draft_redirect)) {
            window.location = Pixfizz.Shopify.cart_target || `${Shopify.routes.root}cart`;
          } else if (is_draft_add && Pixfizz.Shopify.skip_draft_redirect) {
            Pixfizz.Shopify.closeModal();
            Pixfizz.Shopify._showDraftToast();
            fetch(`${Shopify.routes.root}cart.js`)
              .then(r => r.json())
              .then(cart => {
                const bubble = document.querySelector('.cart-count-bubble');
                if (bubble) {
                  bubble.querySelector('[aria-hidden]').textContent = cart.item_count;
                  bubble.querySelector('.visually-hidden').textContent = cart.item_count + ' items';
                }
              })
              .catch(() => {});
          }
        }).catch(() => {
          const is_draft_add = evt.data.data.properties && evt.data.data.properties._pixfizz_draft === true;
          if (is_draft_add && Pixfizz.Shopify.skip_draft_redirect) {
            Pixfizz.Shopify.closeModal();
            Pixfizz.Shopify._showDraftToast();
            fetch(`${Shopify.routes.root}cart.js`)
              .then(r => r.json())
              .then(cart => {
                const bubble = document.querySelector('.cart-count-bubble');
                if (bubble) {
                  bubble.querySelector('[aria-hidden]').textContent = cart.item_count;
                  bubble.querySelector('.visually-hidden').textContent = cart.item_count + ' items';
                }
              })
              .catch(() => {});
          }
        });
        break;
      }
      case 'update_cart_item': {
        updateProjectInCart(
          evt.data.data.key,
          evt.data.data.quantity,
          evt.data.data.properties,
          evt.data.data.addons,
          evt.data.data.pixfizz_properties
        ).then(() => {
          window.location = `${Shopify.routes.root}cart`;
        });
        break;
      }
    }
  });

  window.addEventListener('popstate', (evt) => {
    if (evt.state && evt.state.pixfizz && evt.state.type === 'launch_project') {
      if (Pixfizz.Shopify._modal) {
        Pixfizz.Shopify.closeModal();
      }
      Pixfizz.Shopify.launchProject(evt.state.data.project_id, evt.state.data.parameters, {push_state: false});
    } else if (Pixfizz.Shopify._modal) {
      Pixfizz.Shopify.closeModal();
    }
  });

  window.addEventListener('DOMContentLoaded', (evt) => {
    const url = new URL(window.location);
    const project_data = url.searchParams.get('project-designer');
    if (project_data) {
      if (Pixfizz.Shopify._modal) {
        Pixfizz.Shopify.closeModal();
      }
      const data = JSON.parse(atob(project_data));
      const options = Object.assign(data.options || {}, {push_state: false});
      Pixfizz.Shopify.launchProject(data.project_id, data.parameters, options);
    }
  });
})();